<template>
  <div class="index">
    <van-nav-bar title="淋巴瘤诊疗观念调研2" fixed left-arrow @click-left="$router.go(-1)" />
    <div class="index-head">淋巴瘤诊疗观念调研2</div>
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="105px" class="form" label-position="left">
      <div class="box">
        <div class="box-head">
          <div class="box-head-title">
            为了进一步推动CAR-T疗法在LBCL治疗中的规范化管理，特诚邀血液肿瘤领域的各位专业医师参与本次调研。本问卷旨在了解当前国内CAR-T细胞治疗的临床应用现状，以及医师们对LBCL治疗的诊疗观念。</div>
          <ul class="box-head-ul">
            <li class="box-head-ul-li">1. 本次调研所有信息仅用于学术研究，不涉及商业用途。</li>
            <li class="box-head-ul-li">2. 请根据实际情况作答，确保所填信息的完整性和准确性，请勿虚构数据或歪曲事实。</li>
            <li class="box-head-ul-li">3. 患者的个人信息将匿名处理，确保隐私安全。</li>
            <li class="box-head-ul-name">本问卷预计耗时约20分钟，感谢您的耐心填写。</li>
          </ul>
          <div>
            <div class="form-head-input">
              <el-form-item class="form-dis-item" label="医生姓名：" prop="name">
                <el-input v-model="form.name" placeholder="请输入医生姓名" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在医院：" prop="hospital">
                <el-input v-model="form.hospital" placeholder="请输入所在医院" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在科室：" prop="department">
                <el-input v-model="form.department" placeholder="请输入所在科室" :disabled="true" />
              </el-form-item>
              <el-form-item label="职称：" prop="title" class="form-dis-item-left">
                <el-input v-model="form.title" placeholder="请输入职称" :disabled="true" />
              </el-form-item>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院级别：" prop="rank">
                <el-radio-group v-model="form.rank" class="form-dis-radio" :disabled="true">
                  <el-radio :label="1">一级</el-radio>
                  <el-radio :label="2">二级</el-radio>
                  <el-radio :label="3">三级</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio">
                <el-form-item prop="rank_input" v-if="form.rank == 4">
                  <el-input v-model="form.rank_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院性质：" prop="property" style="margin-bottom: 0;">
                <el-radio-group v-model="form.property" class="form-dis-radio2" :disabled="true">
                  <el-radio :label="1" style="margin-right: 13px;">综合性医院</el-radio>
                  <el-radio :label="2">肿瘤专科医院</el-radio>
                  <el-radio :label="3" style="margin-right: 200px;margin-top: 15px;">民营/私立医院</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio2">
                <el-form-item prop="property_input" v-if="form.property == 4">
                  <el-input v-model="form.property_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 1 -->
        <div class="form-item">
          <el-form-item label="1、您是否使用基因检测来指导淋巴瘤治疗？" prop="lymph2_guide_radio" ref="lymph2_guide_radio" class="box-dis">
            <el-radio-group v-model="form.lymph2_guide_radio" :disabled="true">
              <el-radio :label="1">是，基因检测对治疗选择非常有帮助</el-radio>
              <el-radio :label="2" style="margin: 20px 0 0px 0;">偶尔使用，主要用于特殊情况</el-radio>
              <el-radio :label="3" style="margin: 20px 0 12px 0;">否，认为其成本较高且适用范围有限</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 2 -->
        <div class="form-item">
          <el-form-item label="2、您所在机构主要使用哪种CAR-T产品？（可多选）" prop="lymph2_product_checkbox" ref="lymph2_product_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph2_product_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">阿基仑赛注射液</el-checkbox>
              <el-checkbox label="2" name="type">瑞基奥仑赛注射液</el-checkbox>
              <el-checkbox label="3" name="type">纳基奥仑赛注射液</el-checkbox>
              <el-checkbox label="4" name="type">伊基奥仑赛注射液</el-checkbox>
              <el-checkbox label="5" name="type">泽沃基奥仑赛注射液</el-checkbox>
              <el-checkbox label="6" name="type">西达基奥仑赛注射液</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="7" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph2_product_checkbox_input"
            ref="lymph2_product_checkbox_input" v-if="form.lymph2_product_checkbox.includes('7') == true">
            <el-input v-model="form.lymph2_product_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 3 -->
        <div class="form-item">
          <el-form-item label="3、CAR-T细胞治疗在您的医疗机构适用哪些癌种？（可多选）" prop="lymph2_cancer_checkbox" ref="lymph2_cancer_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph2_cancer_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">成人大B细胞淋巴瘤（LBCL）</el-checkbox>
              <el-checkbox label="2" name="type">滤泡性淋巴瘤（FL）</el-checkbox>
              <el-checkbox label="3" name="type">套细胞淋巴瘤（MCL）</el-checkbox>
              <el-checkbox label="4" name="type">多发性骨髓瘤（MM）</el-checkbox>
              <el-checkbox label="5" name="type">急性淋巴细胞白血病</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="6" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph2_cancer_checkbox_input"
            ref="lymph2_cancer_checkbox_input" v-if="form.lymph2_cancer_checkbox.includes('6') == true">
            <el-input v-model="form.lymph2_cancer_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 4 -->
        <div class="form-item form-item-error">
          <el-form-item label="4、过去一年中，您的机构完成了多少例CAR-T治疗？" prop="lymph2_scale_radio" ref="lymph2_scale_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_scale_radio" :disabled="true">
              <el-radio :label="1">＜5例 </el-radio>
              <el-radio :label="2">5-20例</el-radio>
              <el-radio :label="3">＞20例</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 5 -->
        <div class="form-item">
          <el-form-item label="5、您认为当前CAR-T治疗的主要限制因素是什么？（可多选）" prop="lymph2_factor_checkbox" ref="lymph2_factor_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph2_factor_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">治疗费用</el-checkbox>
              <el-checkbox label="2" name="type">产品供应</el-checkbox>
              <el-checkbox label="3" name="type">治疗副作用</el-checkbox>
              <el-checkbox label="4" name="type">医生缺乏经验</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop=" lymph2_factor_checkbox_input"
            ref="lymph2_factor_checkbox_input" v-if="form.lymph2_factor_checkbox.includes('5') == true">
            <el-input v-model="form.lymph2_factor_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 6 -->
        <div class="form-item form-item-error">
          <el-form-item label="6、CAR-T治疗的副作用管理在您所在机构的成熟度如何？" prop="lymph2_ripe_radio" ref="lymph2_ripe_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_ripe_radio" :disabled="true">
              <el-radio :label="1">非常成熟</el-radio>
              <el-radio :label="2">较成熟</el-radio>
              <el-radio :label="3">不成熟</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 7 -->
        <div class="form-item form-item-error">
          <el-form-item label="7、您所在机构是否定期举办CAR-T治疗的相关培训？" prop="lymph2_cultivate_radio" ref="lymph2_cultivate_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_cultivate_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 8 -->
        <div class="form-item form-item-error">
          <el-form-item label="8、您所在科室的医生对CAR-T疗效的总体评价是？" prop="lymph2_appraise_radio" ref="lymph2_appraise_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_appraise_radio" :disabled="true">
              <el-radio :label="1">非常满意</el-radio>
              <el-radio :label="2">较满意</el-radio>
              <el-radio :label="2">有待提高</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 9 -->
        <div class="form-item form-item-error">
          <el-form-item label="9、在您看来，CAR-T疗法未来能否大范围推广？" prop="lymph2_scope_radio" ref="lymph2_scope_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_scope_radio" :disabled="true">
              <el-radio :label="1">非常可能</el-radio>
              <el-radio :label="2">较可能</el-radio>
              <el-radio :label="3">可能性较小</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph_flup_radio_input" ref="lymph_flup_radio_input"
            v-if="form.lymph_flup_radio == 4">
            <el-input v-model="form.lymph_flup_radio_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 10 -->
        <div class="form-item form-item-error">
          <el-form-item label="10、是否遇到患者主动咨询CAR-T治疗的情况？" prop="lymph2_circumstances_radio"
            ref="lymph2_circumstances_radio" class="box-dis">
            <el-radio-group v-model="form.lymph2_circumstances_radio" :disabled="true">
              <el-radio :label="1">经常</el-radio>
              <el-radio :label="2">偶尔</el-radio>
              <el-radio :label="3">很少</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 11 -->
        <div class="form-item form-item-error">
          <el-form-item label="11、您认为CAR-T治疗的获益人群是否需要进一步定义？" prop="lymph2_definition_radio" ref="lymph2_definition_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_definition_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 12 -->
        <div class="form-item">
          <el-form-item label="12、您如何处理CAR-T治疗中的细胞因子风暴（CRS）（多选）？" prop="lymph2_storm_checkbox" ref="lymph2_storm_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph2_storm_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">及时使用抗IL-6药物（如托珠单抗）</el-checkbox>
              <el-checkbox label="2" name="type">使用糖皮质激素</el-checkbox>
              <el-checkbox label="3" name="type">支持性治疗（如抗生素、抗病毒）</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="4" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph2_storm_checkbox_input"
            ref="lymph2_storm_checkbox_input" v-if="form.lymph2_storm_checkbox.includes('4') == true">
            <el-input v-model="form.lymph2_storm_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 13 -->
        <div class="form-item form-item-error">
          <el-form-item label="13、您对国内CAR-T研发技术的信心如何？" prop="lymph2_confidence_radio" ref="lymph2_confidence_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph2_confidence_radio" :disabled="true">
              <el-radio :label="1">非常有信心</el-radio>
              <el-radio :label="2">一般</el-radio>
              <el-radio :label="3">有待观察</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 14 -->
        <div class="form-item">
          <el-form-item label="14、您希望通过CAR-T技术进一步解决哪些难题？（开放题）" prop="lymph2_problem" ref="lymph2_problem" class="box-dis">
            <div class="box-bottom-15">
              <el-input style="width: 100%;" type="textarea" v-model="form.lymph2_problem" placeholder="请输入内容"
                :disabled="true" />
            </div>
          </el-form-item>
        </div>
        <!-- 16 -->
        <!-- <div class="form-item"></div> -->
        <!-- 结束 -->
        <div class="dibu">
          <div class="dibu-img"><img src="@/assets/image/survey/anquan.png"></div>
          <div class="dibu-name">隐私保护</div>
        </div>
        <div style="margin-bottom: 10px;">您提供的个人信息和回答将仅用于统计分析和研究。</div>
        <div>非常感谢您抽出宝贵时间参与本次调查，您的意见和建议对我们非常重要！</div>
        <!-- 按钮 -->
        <!-- <div class="btn">
          <el-form-item class="btn-form">
            <el-button style="width: 100%; border-radius:18px;" type="primary"
              @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </div> -->
      </div>
    </el-form>
    <!--  -->
  </div>
</template> 
<script>
export default {
  name: 'survey2',
  data() {
    return {
      form: {
        name: '', //姓名
        hospital: '',//医院   
        department: '',//科室
        title: '',//职称 
        rank: '',//级别
        rank_input: '',//级别其他
        property: '',//性质 
        property_input: '',//性质其他
        //@@@@@@@@@@@@@@@@@@@@@@@@@@@@
        lymph2_guide_radio: '',//指导  
        lymph2_product_checkbox: [],//car-t产品
        lymph2_product_checkbox_input: '',//car-t产品输入框 

        lymph2_cancer_checkbox: [],//癌种 
        lymph2_cancer_checkbox_input: '',//癌种输入框

        lymph2_scale_radio: '',//比例

        lymph2_factor_checkbox: [],//因素
        lymph2_factor_checkbox_input: '',//因素输入框

        lymph2_ripe_radio: '',//成熟

        lymph2_cultivate_radio: '',//培训

        lymph2_appraise_radio: '',//评价

        lymph2_scope_radio: '',//范围

        lymph2_circumstances_radio: '',//情况

        lymph2_definition_radio: '',//定义

        lymph2_storm_checkbox: [],//风暴
        lymph2_storm_checkbox_input: '',//风暴输入框

        lymph2_confidence_radio: '',//信心

        lymph2_problem: '',//难题  
      },
      rules: {
        name: [{ required: true, message: '请输入医生姓名', trigger: 'blur' },],
        hospital: [{ required: true, message: '请输入所在医院', trigger: 'blur' }],
        department: [{ required: true, message: '请输入所在科室', trigger: 'blur' }],
        title: [{ required: true, message: '请输入所职称', trigger: 'blur' }],
        rank: [{ required: true, message: '请选择医院级别', trigger: 'change' }],
        rank_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        property: [{ required: true, message: '请选择医院性质', trigger: 'change' }],
        property_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@   
        lymph2_guide_radio: [{ required: true, message: '请选择是否使用基因检测来指导淋巴瘤治疗', trigger: 'change' }],
        lymph2_product_checkbox: [{ required: true, message: '请选择您所在机构主要使用哪种CAR-T产品', trigger: 'change' }],
        lymph2_product_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph2_cancer_checkbox: [{ required: true, message: '请选择CAR-T细胞治疗在您的医疗机构适用哪些癌种', trigger: 'change' }],
        lymph2_cancer_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph2_scale_radio: [{ required: true, message: '请选择您的机构完成了多少例CAR-T治疗', trigger: 'change' }],

        lymph2_factor_checkbox: [{ required: true, message: '请选择您认为当前CAR-T治疗的主要限制因素是什么', trigger: 'change' }],
        lymph2_factor_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph2_ripe_radio: [{ required: true, message: '请选择CAR-T治疗的副作用管理在您所在机构的成熟度如何', trigger: 'change' }],

        lymph2_cultivate_radio: [{ required: true, message: '请选择您所在机构是否定期举办CAR-T治疗的相关培训', trigger: 'change' }],

        lymph2_appraise_radio: [{ required: true, message: '请选择您所在科室的医生对CAR-T疗效的总体评价是', trigger: 'change' }],

        lymph2_scope_radio: [{ required: true, message: '请选择CAR-T疗法未来能否大范围推广', trigger: 'change' }],

        lymph2_circumstances_radio: [{ required: true, message: '请选择是否遇到患者主动咨询CAR-T治疗的情况', trigger: 'change' }],

        lymph2_definition_radio: [{ required: true, message: '请选择您认为CAR-T治疗的获益人群是否需要进一步定义', trigger: 'change' }],

        lymph2_storm_checkbox: [{ required: true, message: '请选择您如何处理CAR-T治疗中的细胞因子风暴（CRS）', trigger: 'change' }],
        lymph2_storm_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph2_confidence_radio: [{ required: true, message: '您对国内CAR-T研发技术的信心如何？', trigger: 'change' }],

        lymph2_problem: [{ required: true, message: '您希望通过CAR-T技术进一步解决哪些难题？', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.getecholist()
  },
  methods: {
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName("is-error");
        errorDiv[0].scrollIntoView();
      }, 0);
    },
    //提交  
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          // this.locateToErr(); 
          console.log('error submit!!');
          return false;
        }
      });
    },
    //提交接口
    async submitApi() {
      const { data: data } = await this.$http.post("/survey/info", { id: this.$route.query.id, form: this.form });
      console.log(data);
      this.$toast(data.message);
      this.$router.push({ path: "survey" });
    },
    //回显数据 
    async getecholist() {
      const { data: data } = await this.$http.get("/survey/info", { params: { id: this.$route.query.id } });
      this.form = data.data
    },
  },
}    
</script> 
<style scoped>
.index {
  position: relative;
  left: -15px;
  width: 108.8%;
}

.index-head {
  position: relative;
  width: 375px;
  height: 96px;
  background: url(@/assets/image/survey/head-bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;

  color: #130F0F;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  position: relative;
  /* top: -20px; */
  left: 0;
  background-color: #F6F8FF;
  width: 100%;
  box-shadow: 0px 0px 6px 1px #A4C4F1;
  border-radius: 15px 15px 0px 0px;
  min-height: calc(100vh - 142px);
  padding: 20px 15px;
  overflow: hidden;
}

.box-head {
  padding: 20px 12px;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
}

.box-head-title {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 25px;
}

.box-head-ul {}

.box-head-ul-li {
  color: #2B2B2B;
  font-size: 14px;
  margin-bottom: 22px;
  padding-left: 4px;
}

.box-head-ul-name {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 30px;
}

.form-head-input>>>.el-input__inner {
  /* width: 120px; */
  width: 60%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
  border-color: #130F0F;
}

.form-dis-radio {
  display: flex;
  flex-wrap: wrap;
}

.form-dis-radio>>>.el-radio {
  margin-right: 20px;
}

.form-dis-box {
  position: relative;
}

.form-dis-box-radio {
  position: absolute;
  top: 27px;
  right: -20px;
}

.form-dis-box-radio>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio>>>.el-form-item__content {
  line-height: 20px !important;
}

.form-dis-box-radio2 {
  position: absolute;
  bottom: -21px;
  right: -20px;
}

.form-dis-radio2>>>.el-radio {
  margin-right: 0px;
}

.form-dis-box-radio2>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio2>>>.el-form-item__content {
  line-height: 20px !important;
}

/* 1 */
.form-item {
  margin-top: 18px;
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
}

.box-dis {
  display: flex;
  flex-wrap: wrap;
  /* margin-bottom: 10px; */
  margin-bottom: 0;
}


.box-dis>>>.el-form-item__label {
  width: 100% !important;
  margin-bottom: 10px;
}

.box-dis>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis-input>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis>>>.el-form-item__error {
  top: 94% !important;
}

.box-dis2 {
  margin-bottom: 10px;
}

.box-bottom-15 {
  width: 321px;
  margin-bottom: 10px;
}

.btn {
  margin-top: 38px;
}

.btn-form>>>.el-form-item__content {
  margin-left: 0 !important;
}

.dibu {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 10px;
}

.dibu-img {
  width: 17px;
  height: 17px;
  margin-right: 4px;
}

.dibu-name {
  color: #000000;
  font-size: 15px;
}

.form-item-error>>>.el-form-item__error {
  min-width: 375px !important;
  top: 80% !important;
}
</style>      